import { pagePaddingSx } from '@shared/theme/layout';

export const DASHBOARD_MAX_WIDTH = 1400;
export const GRID_GAP = 2;

export const dashboardCenterSx = {
  maxWidth: DASHBOARD_MAX_WIDTH,
  margin: '0 auto',
} as const;

/** Centered, full-width dashboard page container with responsive padding. */
export const dashboardPageSx = {
  ...dashboardCenterSx,
  width: '100%',
  ...pagePaddingSx,
} as const;
